import { storeOrUpdateRole } from "@/api/role"
import { getPrivileges } from "@/api/privilege"

export default {
    components: {
    },
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            privileges: [],
            privilegeIds: { checked: [], halfChecked: [] },
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            loading: false,
            rules: {
                name: [ { required: true, message: '请输入角色名称', trigger: 'change' }]
            }
        }
    },
    mounted () {
        getPrivileges().then(res => { this.privileges = res.data.list })
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    methods: {
        defaultCheck(model) {
            this.privilegeIds = model.privilege_ids || []
        },
        autoCheck(keys) {
            this.privilegeIds = keys
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            data.privilege_ids = this.privilegeIds
            this.loading = true
            storeOrUpdateRole(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.privilegeIds = {}
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        }
    }
}
